import React, {Component} from 'react';
import Moment from "moment";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import {Card} from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import Paper from "@material-ui/core/Paper";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

//                     2019-09-19 22:38:23,920
//                     19/10/02 17:14:15
const FORMAT_STRING = ["YY/MM/DD HH:mm:ss", "YYYY/MM/DD HH:mm:ss", "hh:mm:ss"];

class TimeCalc extends Component {
    constructor(props) {
        super(props);
        this.inputLabel = React.createRef();
        this.state = {
            timeFrom : null,
            timeTo : null,
            parsedTimeFrom: null,
            parsedTimeTo: null,
            result: null,
            currentFormatString: null,
            formatStrings : [...FORMAT_STRING],
            labelWidth: null,
        }
    }

    onChangeHandler(newValue, property) {
        this.setState((state) => {
            return {[property]: newValue};
        });
    }

    componentDidMount() {
        this.setState({labelWidth: this.inputLabel.current.offsetWidth});
    }




    parseDate(date) {
        if (Moment(date).isValid()) {
            return Moment(date);
        } else if (this.state.customFormatString && Moment(date, this.state.customFormatString).isValid()) {
            return Moment(date, this.state.customFormatString);
        } else {
            for (let i = 0; i < FORMAT_STRING.length; i++) {
                if (Moment(date, FORMAT_STRING[i]).isValid()) {
                    return Moment(date, FORMAT_STRING[i]);
                }
            }
        }
    }

    onClickHandler() {
        const from = this.parseDate(this.state.timeFrom);
        const to = this.parseDate(this.state.timeTo);
        this.setState((state)=>{
            return {
                parsedTimeFrom: from,
                parsedTimeTo: to,
                result: to.diff(from, "minutes", true),
            }
        })
    }

    render() {
        return (
            <div className={'timeCalc'}>
                <Paper className={"timeCalc__paper"}>
                <TextField
                    id="outlined-name"
                    label="From"
                    value={this.state.timeFrom}
                    onChange={(e)=> this.onChangeHandler(e.target.value, "timeFrom")}
                    margin="normal"
                    variant="outlined"
                    fullWidth
                />
                <br/>
                <TextField
                    id="outlined-name"
                    label="To"
                    value={this.state.timeTo}
                    onChange={(e)=> this.onChangeHandler(e.target.value, "timeTo")}
                    margin="normal"
                    variant="outlined"
                    fullWidth
                />
                    <FormControl variant="outlined" fullWidth>
                        <InputLabel ref={this.inputLabel} htmlFor="outlined-age-simple">
                            Format String
                        </InputLabel>
                        <Select
                            value={this.state.currentFormatString}
                            onChange={(e)=> this.onChangeHandler(e.target.value, "currentFormatString")}
                            labelWidth={this.state.labelWidth}
                            inputProps={{
                                name: 'Format String',
                                id: 'outlined-age-simple',
                            }}
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            {this.state.formatStrings.map((s)=><MenuItem value={s}>{s}</MenuItem>)}
                        </Select>
                    </FormControl>
                <h1>{this.state.result !== null? this.state.result+" minutes": null} </h1>
                <Button variant="contained" color="primary" onClick={(e)=> this.onClickHandler()}>
                    Calculate!!!
                </Button>
                </Paper>
            </div>
        );
    }

}


export default TimeCalc;